import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';


import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import Tooltip from '@mui/material/Tooltip';

import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import SpeedDialAction from '@mui/material/SpeedDialAction';

import FileCopyIcon from '@mui/icons-material/FileCopyOutlined';

const styles = theme => ({

    fab: {
        top: 'auto',
        left: 'auto',
        bottom: 20,
        right: 20,
        position: 'fixed',
        zIndex: 1500
    },

    root: {
        width: '100%'
    },
    controls: {
        margin: theme.spacing(3)
    },
    exampleWrapper: {
        top: 'auto',
        left: 'auto',
        bottom: 0,
        right: 0,
        position: 'fixed',
        zIndex: 1500,
        height: 380
    },
    radioGroup: {
        margin: theme.spacing(1, 0)
    },
    speedDial: {
        position: 'absolute',
        bottom: 20,
        right: 20
    }
});

const actions = [
    { icon: <FileCopyIcon />, name: 'Import fichier souffrances transporteur' }
];

class AddReclamationButton extends React.Component {
    state = {
        open: false,
        hidden: false
    };

    handleClick = (event, actionName) => {

        event.preventDefault();

        this.setState(state => ({
            open: !state.open
        }));


        this.props.onClick(actionName);
    };


    handleHiddenChange = (event, hidden) => {
        this.setState(state => ({
            hidden,
            // hidden implies !open
            open: hidden ? false : state.open
        }));
    };

    handleClose = () => {
        this.setState({ open: false });
    };

    handleOpen = () => {
        this.setState({ open: true });
    };

    render() {
        const { classes, onClick, disabled, avecSouffrance } = this.props;

        const { hidden, open } = this.state;

        let fabProps = {
            color: "secondary"
        };
        if (disabled) {
            fabProps.disabled = true;
        }

        return (
            <React.Fragment>
                {(!avecSouffrance) && (
                    <Tooltip title="Créer un dossier après-vente" placement="left" disableFocusListener>
                        <Fab color="secondary" className={classes.fab} onClick={onClick} disabled={disabled} disableFocusRipple disableTouchRipple>
                            <AddIcon />
                        </Fab>
                    </Tooltip>
                )}


                {avecSouffrance && (
                    <div className={classes.exampleWrapper}>
                        <Tooltip title="Créer un dossier après-vente" placement="left-end" disableFocusListener>
                            <SpeedDial
                                ariaLabel="add-reclamation-button"
                                className={classes.speedDial}
                                hidden={hidden}
                                FabProps={fabProps}
                                icon={<SpeedDialIcon openIcon={<AddIcon />} onClick={this.handleClick} />}
                                onClose={this.handleClose}
                                onOpen={this.handleOpen}
                                open={open}
                            >
                                {actions.map(action => (
                                    <SpeedDialAction
                                        key={action.name}
                                        icon={action.icon}
                                        tooltipTitle={action.name}
                                        onClick={event => this.handleClick(event, action.name)}
                                    />
                                ))}
                            </SpeedDial>
                        </Tooltip>
                    </div>
                )}
            </React.Fragment>
        );

    }
}

AddReclamationButton.propTypes = {
    disabled: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    avecSouffrance: PropTypes.bool.isRequired
};

export default withStyles(styles)(AddReclamationButton);